import React from 'react';
import './Materialsled.css';
import housi from '../../../imgs/housing.webp';

const Materialsled = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">The Most Popular Materials for LED Light Housings</h2>
                <p className="Material-date">Nov. 25, 2022</p>
                <div className="Material">
                    <img src={housi} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Material-text">Aluminum is the most commonly used metal material for 
                    the production of LED lamp shades, and as a very popular material, 
                    aluminum has been used in many kinds of LED lamps for a long time.
                    chemical industry, lubricating oil industry and paint and coating industry.</p>
                <p className="Material-text">The lighting industry is advancing with the rapid development of
                     material science, and new materials are sought in the Led lighting industry to produce light,
                     functional and beautiful Led lamps.</p>
                <p className="Material-text">Due to the thermal conductivity and light weight of plastic, 
                    it is obviously a good choice for making Led lighting housings. 
                    So now plastic is an increasingly popular material in the lighting industry</p>
            </div>
        </div>
    );
};
export default Materialsled;
